import { ICommonSettings, IGpsTrackingPermissionLabelSetting, ILanguageModel } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigGpsTrackingPermissionLabelsSettings } from "./app-settings-config-gps-tracker-permission";

export interface IConfigGpsTrackingPermissionInputState {
  showGpsTrackingPermissionLabelsModal: boolean;
  editingGpsTrackingPermissionLabelsId: string;
}

export interface IConfigGpsTrackingPermissionInputProps {
  parentData: string;
  languages: ILanguageModel[];
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigGpsTrackingPermissionInput extends PureComponent<
  IConfigGpsTrackingPermissionInputProps,
  IConfigGpsTrackingPermissionInputState
> {
  formInputName = ["", "gpsTrackingPermissionLabelSettingsId"];

  constructor(props: IConfigGpsTrackingPermissionInputProps) {
    super(props);
    this.formInputName[0] = props.parentData;
    this.state = {
      showGpsTrackingPermissionLabelsModal: false,
      editingGpsTrackingPermissionLabelsId: ""
    };
  }

  openGpsTrackingPermissionLabelsModal = () => {
    this.setState({
      editingGpsTrackingPermissionLabelsId: "",
      showGpsTrackingPermissionLabelsModal: true
    });
  };

  closeGpsTrackingPermissionLabelsModal = () => {
    this.setState({ showGpsTrackingPermissionLabelsModal: false });
  };

  setEditingGpsTrackingPermissionLabels = (id: string) => {
    this.setState({
      editingGpsTrackingPermissionLabelsId: id,
      showGpsTrackingPermissionLabelsModal: true
    });
  };

  render() {
    const options = [
      {
        id: null,
        name: "Default"
      } as unknown as IGpsTrackingPermissionLabelSetting,
      ...(this.props.commonSettings.gpsTrackingPermissionLabelSettings || [])
    ];
    return (
      <>
        <ConfigGpsTrackingPermissionLabelsSettings
          formInputName={this.formInputName}
          closeModal={this.closeGpsTrackingPermissionLabelsModal}
          showModal={this.state.showGpsTrackingPermissionLabelsModal}
          editingGpsTrackingPermissionLabelsId={this.state.editingGpsTrackingPermissionLabelsId}
          languages={this.props.languages}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Permission text"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey={
            this.props.parentData === "androidConfig"
              ? "android_gpstracker_permissiontext"
              : "ios_gpstracker_permissiontext"
          }
          onAddNew={this.openGpsTrackingPermissionLabelsModal}
          onEdit={this.setEditingGpsTrackingPermissionLabels}
          dropdownTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_gpstracker_permissiontext"
              : "ios_gpstracker_permissiontext"
          }Dropdown`}
          addNewTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_gpstracker_permissiontext"
              : "ios_gpstracker_permissiontext"
          }AddNewButton`}
          editTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_gpstracker_permissiontext"
              : "ios_gpstracker_permissiontext"
          }EditButton`}
        />
      </>
    );
  }
}
